import { ClipLoader } from "react-spinners";

export const PageHolder = () => (
    <div className="h-screen flex items-center justify-center">
        <ClipLoader size={24} speedMultiplier={0.5} color="#AAA" />
    </div>
);
